import { matchVersion } from '../../utils';
import __regexp from './__chrome-ios-regexp';
/** Detect Google Chrome Browser version on iOS */
export default function isChromeIOSVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
